module.exports = __webpack_public_path__ + "static/media/ammar.3fe057bf.jpg";